var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.errors.any() || _vm.submitted || _vm.pending},on:{"click":_vm.save}},[(_vm.submitted)?_c('i',{staticClass:"far fa-spinner-third fa-spin"}):_vm._e(),_vm._v(" Save ")])
}
var staticRenderFns = []

export { render, staticRenderFns }